__turbopack_context__.v({
  "section-conclusion": "ZT76Ea_section-conclusion",
  "section-conclusion__animation": "ZT76Ea_section-conclusion__animation",
});
